import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };


  return (
    <section className="contact" id="contact">
      <div className="contact-container">
        {/* Section Header */}
        <div className="contact-header">
          <h2 className="contact-title">
            Get in Touch
          </h2>
          <p className="contact-subtitle">
            We'd love to hear from you! Whether you have questions about our menu, 
            want to make a reservation, or just want to say hello, we're here to help.
          </p>
        </div>

        <div className="contact-content">
          {/* Image Details Section */}
          <div className="image-details-section">
            <h3 className="image-details-title">Experience Our Authentic Indian Cuisine</h3>
            <p className="image-details-subtitle">
              Discover the rich flavors and beautiful presentation of our traditional Indian dishes
            </p>
            
            <div className="image-gallery">
              <div className="image-item">
                <img src={require('../assets/butter-chicken.jpg')} alt="Butter Chicken" className="gallery-image" />
                <div className="image-overlay">
                  <h4>Butter Chicken</h4>
                  <p>Our signature creamy tomato curry</p>
                </div>
              </div>
              
              <div className="image-item">
                <img src={require('../assets/roti.jpg')} alt="Fresh Roti" className="gallery-image" />
                <div className="image-overlay">
                  <h4>Fresh Roti</h4>
                  <p>Handmade traditional bread</p>
                </div>
              </div>
              
              <div className="image-item">
                <img src={require('../assets/m1.jpg')} alt="Traditional Curry" className="gallery-image" />
                <div className="image-overlay">
                  <h4>Traditional Curry</h4>
                  <p>Authentic spices and flavors</p>
                </div>
              </div>
              
              <div className="image-item">
                <img src={require('../assets/m2.jpg')} alt="Indian Appetizers" className="gallery-image" />
                <div className="image-overlay">
                  <h4>Indian Appetizers</h4>
                  <p>Perfect start to your meal</p>
                </div>
              </div>
             
              
             
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-section">
            <div className="form-container">
              <h3 className="form-title">Send us a Message</h3>
              <p className="form-subtitle">
                Fill out the form below and we'll get back to you as soon as possible.
              </p>
              
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name" className="form-label">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-input"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email" className="form-label">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-input"
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone" className="form-label">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject" className="form-label">Subject *</label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      className="form-select"
                      required
                    >
                      <option value="">Select a subject</option>
                      <option value="reservation">Reservation Inquiry</option>
                      <option value="menu">Menu Questions</option>
                      <option value="catering">Catering Services</option>
                      <option value="feedback">Feedback</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="form-label">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-textarea"
                    rows="5"
                    placeholder="Tell us how we can help you..."
                    required
                  ></textarea>
                </div>

                <button type="submit" className="submit-btn">
                  <i className="fas fa-paper-plane"></i>
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>


      </div>
    </section>
  );
};

export default Contact;
